import { useEffect } from "react";
import SearchIcon from "../../assets/images/search.svg";
import CloseIcon from "../../assets/images/closeIcon.svg";
import {
  CloseIconWrapper,
  PlaceholderText,
  SearchIconWrapper,
  SearchInput,
  SearchWrapper,
} from "./SearchStyled";
import PropTypes from 'prop-types';

const Search = ({ searchbarwidth = "380px", searchPlaceholder, isLoading, handleSearch, handleSearchOnChange, inputValue }) => {

  // Debounce logic
  useEffect(() => {
    const trimmedInput = inputValue.trim();
    if (inputValue === '') {
      handleSearch('');
      return;
    }
    if (trimmedInput === '') return;
    const delayDebounce = setTimeout(() => {
      handleSearch(trimmedInput);
    }, 1000);
    return () => clearTimeout(delayDebounce);
  }, [inputValue]);

  const handleInputChange = (e) => {
    if (!isLoading) {
      handleSearchOnChange(e.target.value);
    }
  };

  const handleClearSearch = () => {
    handleSearchOnChange("")
  };

  return (
    <SearchWrapper>
      <SearchIconWrapper src={SearchIcon} alt="Search" />
      <SearchInput
        type="text"
        onChange={handleInputChange}
        value={inputValue}
        maxLength={200}
        searchbarwidth={searchbarwidth}
        placeholder="Search"
      />
      {!inputValue && (
        <PlaceholderText>
          {searchPlaceholder}
        </PlaceholderText>
      )}
      <CloseIconWrapper
        src={CloseIcon}
        alt="Clear search"
        show={inputValue && inputValue.length > 0}
        onClick={handleClearSearch}
      />
    </SearchWrapper>
  );
};

Search.propTypes = {
  handleSearch: PropTypes.func.isRequired,
  searchPlaceholder: PropTypes.string.isRequired,
  searchbarwidth: PropTypes.string,
  isLoading: PropTypes.bool,
  handleSearchOnChange: PropTypes.func.isRequired,
  inputValue: PropTypes.string
};

Search.defaultProps = {
  searchbarwidth: "380px",
  isLoading: false,
  inputValue: ''
};

export default Search;
